import { RowWrapper } from 'src/components/foundations/foundations.styles';
import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const ActiveLabel = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const StepperContainer = RowWrapper;

export const StepperStep = styled(RowWrapper)`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  justify-content: space-between;
`;

export const StepperSpacer = styled.span`
  width: 10px;
`;
